'use client'

import { useEffect } from 'react'

import { useSession } from 'next-auth/react'

import { setDatadogUser } from '@/lib/datadog-init'

export default function DatadogSessionTracker() {
  const { data: session } = useSession()

  useEffect(() => {
    if (session?.user?.id && session?.user?.email) {
      setDatadogUser({
        id: session.user.id,
        email: session.user.email,
      })
    }
  }, [session])

  return null
}
